
import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CaptainTCCashbackCardTermsContent from '../../components/CaptainTCCashbackCardTerms/CaptainTCCashbackCardTerms';

const CaptainTCCashbackCardTermsPage = (props) => {

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    <PageTitle pageTitle={'Captain TC Reward Card Terms & Conditions '} pagesub={'Home'} />
                    <CaptainTCCashbackCardTermsContent abClass={'pt-0'}/>
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default CaptainTCCashbackCardTermsPage;
